export default __webpack_public_path__ + "static/media/test-tube-white.6f5e9c34.svg";